export const functions_index = ['functions.index']
export const functions_create = ['functions.create']
export const functions_edit = ['functions.edit']

export default [].concat(
    functions_index,
    functions_create,
    functions_edit
)
